<div class="layout-container content-block">
  <div class="content-block__grid">
    <div class="content-block__image">
      <img [src]="imageUrl" [alt]="imageAlt" class="object-contain md:object-cover" width="588" height="392" fetchpriority="high" loading="eager" />
    </div>
    <div class="lg:col-span-6 lg:pl-[40px]">
      <app-label-badge [label]="label" [color]="labelColor"></app-label-badge>
      <h2 class="content-block__title hero-display-2">{{ heading }}</h2>
      <app-body-html
        [html]="description"
        [customClass]="'content-block__body text-responsive mt-6'"
      ></app-body-html>
    </div>
  </div>
</div>
